class SizeGuideDrawerTabs extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.selectInitialTab()
  }

  setupListeners () {
    super.setupListeners()

    this.els.tab?.elements.forEach((tabEl) => {
      this.listeners.add(tabEl, 'click', this.onTabClick.bind(this))
      this.listeners.add(tabEl, 'keydown', this.onTabKeydown.bind(this))
    })
  }

  onTabClick (event) {
    this.selectTab(event.currentTarget)
  }

  onTabKeydown (event) {
    const key = event.key

    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return

    event.preventDefault()

    const tabEls = this.els.tab.elements
    const currentIndex = tabEls.indexOf(event.currentTarget)

    if (currentIndex === -1) return

    let nextIndex = currentIndex

    if (key === 'ArrowLeft') {
      nextIndex = currentIndex - 1

      if (nextIndex < 0) nextIndex = tabEls.length - 1
    }

    if (key === 'ArrowRight') {
      nextIndex = currentIndex + 1

      if (nextIndex > tabEls.length - 1) nextIndex = 0
    }

    if (key === 'Home') nextIndex = 0
    if (key === 'End') nextIndex = tabEls.length - 1

    const nextTabEl = tabEls[nextIndex]

    if (!nextTabEl) return

    this.selectTab(nextTabEl)
    nextTabEl.focus()
  }

  selectInitialTab () {
    const pressedTabEl = this.els.tab?.elements.find((tabEl) => {
      return tabEl.getAttribute('aria-pressed') === 'true'
    })

    this.selectTab(pressedTabEl || this.els.tab?.elements[0])
  }

  selectTab (selectedTabEl) {
    if (!selectedTabEl) return

    const selectedPanelId = selectedTabEl.getAttribute('aria-controls')

    this.els.tab.elements.forEach((tabEl) => {
      const isActive = tabEl === selectedTabEl

      tabEl.setAttribute('aria-pressed', isActive ? 'true' : 'false')
      tabEl.setAttribute('aria-selected', isActive ? 'true' : 'false')
      tabEl.setAttribute('tabindex', isActive ? '0' : '-1')
    })

    this.els.panel.elements.forEach((panelEl) => {
      const isActive = panelEl.id === selectedPanelId

      panelEl.setAttribute('aria-hidden', isActive ? 'false' : 'true')
      panelEl.hidden = !isActive
    })
  }
}

if (!customElements.get('size-guide-drawer-tabs')) {
  customElements.define('size-guide-drawer-tabs', SizeGuideDrawerTabs)
}
